import React from "react";
import Link from "next/link";

import classes from "@/styles/generic/sitemap-main.module.css";
import { routes } from "@/utils/routes";

const siteMapData: {
  title: string;
  links: {
    name: string;
    link: string;
    isExternal?: boolean;
  }[];
}[] = [
  {
    title: "Links",
    links: [
      {
        name: "Home",
        link: routes.home,
      },
      {
        name: "Get Instant Quotes",
        link: routes.getQuote,
      },
      {
        name: "About Us",
        link: routes.about,
      },
      {
        name: "Track My Shipments",
        link: routes.trackShipment,
      },
    ],
  },
  {
    title: "Learn",
    links: [
      {
        name: "How It Works",
        link: routes.howItWorks,
      },
      {
        name: "Privacy Policy",
        link: routes.privacyPolicy,
      },
      {
        name: "Terms And Conditions",
        link: routes.terms,
      },
      {
        name: "Offers",
        link: routes.openAccountOffer,
      },
      {
        name: "Become An Affiliate",
        link: routes.becomeAnAffiliate,
      },
      {
        name: "Blog",
        link: routes.blog,
      },
    ],
  },
  {
    title: "Support",
    links: [
      {
        name: "FAQ",
        link: routes.help,
      },
      {
        name: "Contact",
        link: routes.contact,
      },
    ],
  },
  {
    title: "Access",
    links: [
      {
        name: "Login",
        link: routes.login,
      },
      {
        name: "Sign Up",
        link: routes.register,
      },
      {
        name: "About Us",
        link: routes.about,
      },
      {
        name: "Reset Password",
        link: routes.resetPassword,
      },
    ],
  },
];

const SitemapMain = () => {
  return (
    <main className={classes.root}>
      <section className={classes.bannerSection}>
        <div className={`${classes.container} container`}>
          <h1>Sitemap</h1>
        </div>
      </section>

      <section>
        <div className={`${classes.container} container`}>
          <div className={classes.cards}>
            {siteMapData.map((category, cIndex) => {
              const { title, links } = category;
              return (
                <div key={cIndex} className={classes.cardArea}>
                  <h4>{title}</h4>
                  <div className={classes.card}>
                    <ul>
                      {links.map((linkDetails, lIndex) => {
                        const { link, name, isExternal } = linkDetails;
                        return (
                          <li key={lIndex}>
                            {isExternal ? (
                              <a href={link} target="_blank" rel="noreferrer">
                                {name}
                              </a>
                            ) : (
                              <Link href={link}>{name}</Link>
                            )}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </main>
  );
};

export default SitemapMain;
